
<div class="offredetailspage section-margin">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <h3 class="bluelabel  margin-bottom-15">Offers</h3>
                <div class="table-responsive">
                    <table class="table basictable large-width-table">
                        <thead>
                            <tr>
                                <th style="width:150px;">Action</th>
                                <th>Date</th>
                                <th>Last Modified User</th>
                                <th>On Behalf Of</th>
                                <th>Status</th>
                                <th>Offer Price</th>
                                <th>Earnest Money Deposit</th>
                                <th>Due Diligence Period (Days)</th>
                                <th>Closing Period (Days)</th>
                                <th>Offer Contingent upon Financing</th>
                                <th>LTV Ratio</th>
                                <th>Interest Rate</th>
                                <th>Term</th>
                                <th>Amortization</th>
                                <th>Is it associated to 1031 Exchange?</th>
                                <th>1031 Exchange</th>
                                <th>Exchange Amount</th>
                                <th>Date Closed Or Closing</th>
                                <th>Do you own other NNN assets?</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of LeadOffersList">
                                <td class="actionbtns">
                                    <a *ngIf="item.FilePath" class="view" href={{item.FilePath}} download="Document.pdf" target="_blank" ng-reflect-placement="top" ng-reflect-tooltip="Download" placement="top" tooltip="Download" triggers="hover">
                                        <i aria-hidden="true" class="icofont icofont-download-alt"></i>
                                    </a>
                                    <!--<a class="blueone" href="{{item.FilePath}}" placement="top" tooltip="Download">
                                        <i aria-hidden="true" class="icon-download"></i>
                                    </a>-->
                                    <!--
                                    <a class="view" href="javascript:void(0);" placement="top" tooltip="File">
                                        <i aria-hidden="true" class="icon-inquiry"></i>
                                    </a>
                                    <a class="bluetwo" href="javascript:void(0);" placement="top" tooltip="Edit">
                                        <i aria-hidden="true" class="icofont icofont-ui-edit"></i>
                                    </a> -->
                                </td>
                                <td><p class="whitespacenowrap">{{item.OfferDate|date:'MM/dd/yyyy hh:mm a'}}</p></td>
                                <td><p class="whitespacenowrap">{{item.UserName}}</p></td>
                                <td *ngIf="item.Status!='Hard Contract' && item.Status != 'Under Contract' && item.Status !='Closed'"><p class="whitespacenowrap">{{item.OnBehalfOf}}</p></td>
                                <td *ngIf="item.Status =='Hard Contract' || item.Status == 'Under Contract' || item.Status =='Closed'"><p class="whitespacenowrap">------</p></td>
                                <td><p class="whitespacenowrap">{{item.Status =='Cancelled' ? 'Canceled' :item.Status}} <span *ngIf="item.IsDraft" class="red">(Draft)</span></p></td>
                                <td><p class="whitespacenowrap">$ {{item.OfferPrice|number}}</p></td>
                                <td><p class="whitespacenowrap">$ {{item.EarnestMoneyDeposit |number}}</p></td>
                                <td>{{item.DueDiligencePeriod}}</td>
                                <td>{{item.ClosingPeriod}}</td>
                                <td>{{item.FinanceRequired}}</td>
                                <td>{{item.LTV ? item.LTV + '%' :'-'}}</td>
                                <td>{{item.InterestRate?item.InterestRate+'%':'-'}}</td>
                                <td><p class="whitespacenowrap">{{item.Term ? item.Term + ' Yrs' : '-'}}</p></td>
                                <td><p class="whitespacenowrap">{{item.Amortization ? item.Amortization +' Yrs' : '-'}}</p></td>
                                <td>{{item.On1031Exchange}}</td>
                                <td><p class="whitespacenowrap">{{item.ExchangeCode ? item.ExchangeCode : '-'}}</p></td>
                                <td><p class="whitespacenowrap">{{item.ExchangeAmount ? '$ '+ (item.ExchangeAmount |number) : '-'}}</p></td>
                                <td>{{item.ExchangeClosingDate == null ?'-': item.ExchangeClosingDate|date:'M/d/yyyy' }}</td>
                                <td>{{item.HaveOtherNNNasset}}</td>

                            </tr>
                        </tbody>
                        <tfoot>
                            <tr *ngIf="LeadOffersList?.length == 0 ">
                                <td colspan="7" class="odd no-data-available">
                                    <div class="nodata">
                                        <i class="fa fa-exclamation-triangle icon"></i>
                                        <p>No Data Available</p>
                                    </div>
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

                <!--<div class="">

                    <div [ngClass]="accordion2">
                        <a class="accordion-head" (click)="toggleClass(2);">Offers</a>
                        <div class="accordion-content">

                        </div>
                    </div>

                </div>-->
            </div>

        </div>
    </div>
</div>

